<template lang="pug">
.page
  //-.max-width
    .row.apart
      .col
      .col
        router-link.button(:to="{ name: 'SettingsCompany' }") Settings

  section
    .max-width
      .sub-section
        .row.center.apart
          .col(v-if="!users || users.length < 2")
            span Invite users to grow your team.
          .col(v-if="users && users.length >= 2")
            span Invite some more users to help collaborate.
          .col
            router-link.button.primary-button(:to="{ name: 'SettingsTeam' }") Invite Users

  section
    .max-width
      //-.tabs
        .tab.active
          h2 Boards

      .row.wrapped.gap-2.boards
        .col.board(v-for="board in boards", :key="board._id")
          BoardPreview(:board="board", :admin="true")
            //-.col
              router-link(:to="{ name: 'BoardSettingsGeneral', params: { boardSlug: board.slug }}")
                font-awesome-icon(:icon="['fad', 'cog']")
      .action
        router-link.button(:to="{ name: 'CreateBoard' }")
          span Create Board

  //-ModalOverlay(:open="showOnboarding", @close="closeOnboarding")
    OnboardingTutorial
</template>

<script>

import { mapState } from 'vuex'

import ModalOverlay from '@/components/helpers/ModalOverlay'
import OnboardingTutorial from '@/components/OnboardingTutorial'
import BoardPreview from '@/components/BoardPreview'

export default {
  name: 'Dashboard',
  components: {
    ModalOverlay,
    OnboardingTutorial,
    BoardPreview
  },
  beforeMount () {
    //console.log(this.company)
    //console.log('UNSELECT_BOARD')
    this.$store.commit('boards/UNSELECT_BOARD')
  },
  data () {
    return {
      showOnboarding: true
    }
  },
  computed: {
    ...mapState({
      company: state => state.company,
      boards: state => state.boards.list,
      users: state => state.users
    })
  },
  methods: {
    closeOnboarding () {
      //console.log('closing onboarding')
      this.showOnboarding = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .boards
    padding-bottom 3rem
  .board
    width 33.33%
    max-width 33.33%
    min-width 33.33%
    +for_breakpoint(mobile)
      min-width 100%
      max-width 100%

</style>
